export default "__VITE_ASSET__1nWYWb4Q__"